import React from 'react';

import { CustomNavigationItemType, GqlCustomNavigationItem } from 'types/graphql';
import { AddLinkModal } from './add-link-modal';
import { AddCollectionModal } from './add-collection-modal';
import { AddCategoryModal } from './add-category-modal';
import { AddBrandModal } from './add-brand-modal';
import { AddSectionModal } from './add-section-modal';

export type ModalControllerProps = {
  editingItem: GqlCustomNavigationItem | null;
  itemType: CustomNavigationItemType;
  onClose: () => void;
  onSave: (item: GqlCustomNavigationItem) => void;
};

const itemTypeToModal: Record<CustomNavigationItemType, React.FC<ModalControllerProps>> = {
  [CustomNavigationItemType.brand]: AddBrandModal,
  [CustomNavigationItemType.category]: AddCategoryModal,
  [CustomNavigationItemType.collection]: AddCollectionModal,
  [CustomNavigationItemType.link]: AddLinkModal,
  [CustomNavigationItemType.section]: AddSectionModal,
};

export function ModalController(props: ModalControllerProps): JSX.Element | null {
  const { itemType } = props;
  const Modal = itemTypeToModal[itemType];

  return <Modal {...props} />;
}
